import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/h-logo.svg")